/** @import modules */

import { useTranslation }               from "react-i18next";

import { useParams, useNavigate }       from "react-router-dom";

/** @import hooks */

import { BatteriesNavigator }           from "../../../../../Hooks/BatteriesNavigator";

/** @import components */

import SearchableSelect                 from "../../../../Shared/SearchableSelect";

/**
 * 
 * @param { attributes } param0 
 * 
 * @returns currents filter component
 * 
 */

const Currents = ( { attributes } ) => { const 
    
    { t } = useTranslation (),

    navigate            = useNavigate       (),

    { parameters }      = useParams         (),

    Filter = ( value ) => { const 

        object = { f : 12, l: null, a: null, b: null, c: ( value === "default" ) ? null : value, loc: window.pageYOffset };

        return navigate (  
            
            `/shop/batteries/${
            
                new URLSearchParams ( BatteriesNavigator ( parameters, object ) ).toString () }` );

    };

    /** @returns component */

    return ( <div className="content currents">

        <label className="select shadow-select">

            <SearchableSelect

                options={ attributes }

                value={ new URLSearchParams ( parameters ).get ( "c" ) || "default" }

                onChange={ Filter }

                label={ t ( "select_option" ) }

            />

        </label>

    </div> );

}

/** Export component */
 
export default Currents;